import useTranslation from 'next-translate/useTranslation'

import Icon from '@/atoms/Icon'
import formatPrice from '@/helpers/formatPrice'

function LowestPrice({ lowestPrice }: LowestPriceProps) {
  const { t } = useTranslation('products')

  return (
    <div className="flex items-center justify-start space-x-2">
      <Icon name="info" className="w-3 text-sbtgray-400" />
      <span className="text-sm text-sbtgray-400">
        {t('price')} {formatPrice(lowestPrice)}
      </span>
    </div>
  )
}

interface LowestPriceProps {
  lowestPrice: number
}

export default LowestPrice
